import React from 'react'
import { Chip } from '@the-platform-group/component-library'
import { DataGridActionCell } from '@the-platform-group/component-library/DataGrid'
import { LinkOff as DisconnectIcon } from '@the-platform-group/component-library/Icons'
import { useConfirmationDialog } from 'components/ConfirmationDialog'
import useEmailAccountMutation from './useEmailAccountMutation'

const PERMISSION_LABELS = {
  email: 'Email tracking',
  calendar_scheduler: 'Scheduler',
}

const useEmailAccountColumnConfig = ({ customerId }) => {
  const { createConfirmationDialog } = useConfirmationDialog()
  const { disconnect } = useEmailAccountMutation({ customerId })

  return [
    {
      field: 'userName',
      headerName: 'User',
      valueGetter: ({ row }) => {
        const name = row.userName || row.name
        return row.userId ? { to: '/users/' + row.userId, text: name } : name
      },
      type: 'link',
      flex: 1,
    },
    {
      field: 'emailAddress',
      headerName: 'Email',
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'Status',
      renderCell: ({ row }) => {
        const isActive = !row.archivedAt
        return (
          <Chip
            label={isActive ? 'Active' : 'Disconnected'}
            color={isActive ? 'success' : 'default'}
            size="small"
          />
        )
      },
    },
    {
      field: 'permissions',
      headerName: 'Permissions',
      flex: 1,
      valueGetter: ({ row }) =>
        row.enabledFeatures
          ?.filter(feature => PERMISSION_LABELS[feature])
          .map(feature => PERMISSION_LABELS[feature])
          .join(', '),
    },
    {
      field: 'actions',
      type: 'actions',
      getActions: ({ row }) => {
        if (row.archivedAt) {
          return []
        }

        return [
          <DataGridActionCell
            icon={<DisconnectIcon />}
            title="Disconnect email account"
            onClick={() => {
              createConfirmationDialog({
                title: `Disconnect ${row.emailAddress}?`,
                body: `Are you sure you want to disconnect the email account ${row.emailAddress}?`,
                onConfirm: () => disconnect.mutate(row.id),
              })
            }}
          />,
        ]
      },
    },
  ]
}

export default useEmailAccountColumnConfig
